import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <span>© {new Date().getFullYear()} Keyu Chen</span>
  </footer>
)

export default Footer

